import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = { class: "visible lg:hidden" }
const _hoisted_3 = { class: "flex justify-end items-center" }
const _hoisted_4 = { class: "sm:flex flex-row w-full items-center" }
const _hoisted_5 = { class: "flex flex-col justify-center lg:flex-row w-full items-center space-y-2 lg:space-y-0" }
const _hoisted_6 = { class: "flex flex-col ml-3 text-center lg:text-left" }
const _hoisted_7 = { class: "hover:underline" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-30 pr-1" }, "(Draft)", -1)
const _hoisted_9 = { class: "flex flex-row space-x-3 items-center text-gray-400 lg:w-72 w-full lg:justify-start justify-center" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_11 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_12 = { class: "flex flex-col lg:flex-row lg:space-x-2 items-center text-xs text-gray-400 capitalize -space-y-2" }
const _hoisted_13 = { class: "truncate" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "·", -1)
const _hoisted_15 = {
  key: 0,
  class: "truncate w-52"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex flex-row justify-center lg:justify-start items-center lg:items-start space-x-1 mt-1 w-full" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs rounded-lg font-light bg-primary-light py-1 px-3 text-primary flex flex-row justify-between items-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4 w-4 text-purple-700 mr-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Managed")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "text-xs rounded-lg font-light bg-primary-light py-1 px-3 text-primary flex flex-row justify-between items-center"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-4 w-4 text-purple-700 mr-2\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\" ry=\"2\"></rect><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect><line x1=\"9\" y1=\"1\" x2=\"9\" y2=\"4\"></line><line x1=\"15\" y1=\"1\" x2=\"15\" y2=\"4\"></line><line x1=\"9\" y1=\"20\" x2=\"9\" y2=\"23\"></line><line x1=\"15\" y1=\"20\" x2=\"15\" y2=\"23\"></line><line x1=\"20\" y1=\"9\" x2=\"23\" y2=\"9\"></line><line x1=\"20\" y1=\"14\" x2=\"23\" y2=\"14\"></line><line x1=\"1\" y1=\"9\" x2=\"4\" y2=\"9\"></line><line x1=\"1\" y1=\"14\" x2=\"4\" y2=\"14\"></line></svg> AI Match", 2)
const _hoisted_25 = [
  _hoisted_23
]
const _hoisted_26 = { class: "flex flex-row my-4 lg:my-0 w-full lg:w-1/3 items-start justify-center" }
const _hoisted_27 = { class: "flex flex-col justify-center items-center" }
const _hoisted_28 = { class: "flex flex-row items-center space-x-2 mt-2" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-gray-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2\"></path></svg><div class=\"block mx-asuto h-8 bg-gray-100 text-center p-2 rounded text-xs text-gray-400\"> - </div><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-gray-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z\"></path></svg>", 3)
const _hoisted_32 = { class: "block mx-asuto h-8 bg-gray-100 text-center p-2 rounded text-xs text-gray-400" }
const _hoisted_33 = { class: "flex flex-col w-full items-start justify-between" }
const _hoisted_34 = { class: "lg:flex flex-row justify-center lg:justify-end items-center lg:items-end w-full lg:visible hidden" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "flex lgflex-row space-x-2 items-center" }
const _hoisted_37 = { class: "flex flex-row justify-center items-center space-x-1" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
  })
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
  })
], -1)
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "w-full flex justify-center flex-col" }
const _hoisted_42 = { class: "flex flex-col w-full mt-3" }
const _hoisted_43 = { class: "flex text-xs text-gray-400 lg:justify-end justify-center capitalize" }
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = { class: "flex flex-row w-full lg:justify-end justify-center" }
const _hoisted_46 = {
  key: 0,
  class: "flex flex-row justify-center text-gray-400"
}
const _hoisted_47 = { class: "boorder flex flex-row w-full text-xs items-center" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-1 h-1 rounded-full bg-green-500 mr-2" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Assigned to: ", -1)
const _hoisted_50 = { class: "text-gray-900 ml-2" }
const _hoisted_51 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_53 = {
  key: 1,
  class: "flex flex-row items-center text-gray-400"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "w-1 h-1 rounded-full bg-red-500" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs ml-1" }, "Pending assignation", -1)
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = {
  key: 0,
  class: "block w-full"
}
const _hoisted_61 = { class: "w-full pb-2" }
const _hoisted_62 = { class: "text-gray-800 text-sm" }
const _hoisted_63 = { class: "hidden sm:flex flex-row justify-around w-full items-center" }
const _hoisted_64 = { class: "space-y-2 justify-items-center grid opacity-40" }
const _hoisted_65 = { class: "text-center flex justify-start items-center 2xl:text-xs sm:text-xxs" }
const _hoisted_66 = {
  key: 0,
  class: "p-4"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = {
  key: 1,
  class: "p-4 text-gray-300 text-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuJob = _resolveComponent("MenuJob")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass([[
      {
        'bg-white border border-gray-400 flex flex-col  ': _ctx.activeItem === index,
      },
    ], "shadow rounded-2xl px-4 py-5 bg-white my-5 justify-between items-center h-full w-full border hover:border-gray-600 relative"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_MenuJob, {
              jobId: item.id,
              hasChallenge: item.has_challenge_assigned,
              showAssing: _ctx.showAssing,
              hasEvaluation: item.has_evaluation,
              isManaged: item.is_managed,
              jobStatus: item.job_status,
              hasRecruiter: item?.responsible_recruiter ? true : false,
              onOpenTemplate: ($event: any) => (_ctx.openTemplate(item.id)),
              onOpenEvaluation: ($event: any) => (_ctx.openTemplate(item.id)),
              onOpenChallenge: ($event: any) => (_ctx.openChallenge(item.id)),
              onDeactivateJob: ($event: any) => (_ctx.deactivateJob(item)),
              onAssignJob: ($event: any) => (_ctx.assignJob(item)),
              onAcceptManageJob: ($event: any) => (_ctx.acceptManageJob(item)),
              isClosedJob: item.is_closed
            }, null, 8, ["jobId", "hasChallenge", "showAssing", "hasEvaluation", "isManaged", "jobStatus", "hasRecruiter", "onOpenTemplate", "onOpenEvaluation", "onOpenChallenge", "onDeactivateJob", "onAssignJob", "onAcceptManageJob", "isClosedJob"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Avatar, {
              name: item && item.title,
              size: "s",
              color: item.workable_id ? 'bg-primary' : 'bg-gray-400'
            }, null, 8, ["name", "color"]),
            _createElementVNode("div", _hoisted_6, [
              (item.job_status !== 'draft')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/jobs/${item.id}/details`,
                    class: "text-lg font-bold items-center flex lg:justify-start justify-center w-full"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: `/edit-job/${item.id}`,
                    class: "text-lg font-bold hover:underline"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])),
              _createElementVNode("div", _hoisted_9, [
                (item?.salary_min && item?.salary_max)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.salaryRange(
                    item.salary_min,
                    item.salary_max,
                    item.currency_salary,
                    item.show_monthly_salary
                  )) + " (" + _toDisplayString(item.salary_type === "neto" ? "Net salary" : "Gross salary") + ") ", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "Define range salary"))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(item.department ? item.department : "Define department"), 1),
                _hoisted_14,
                (!item?.is_remote)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(` ${
                    item.job_location?.location?.street_address
                      ? item.job_location?.location?.street_address
                      : "Define location"
                  }`), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, " Remote "))
              ]),
              _createElementVNode("div", _hoisted_17, [
                (item.is_managed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_21))
                  : _createCommentVNode("", true),
                (item.match_candidates)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_25))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", {
                class: _normalizeClass(["font-normal px-2 py-1 rounded-lg opacity-50 text-xs text-center capitalize-first", [
                item.job_status === 'pending_approval'
                  ? 'bg-orange-100 text-orange-900'
                  : 'bg-green-100 text-green-900',
              ]])
              }, _toDisplayString(item.job_status.replace(/_/g, " ")), 3),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_32, _toDisplayString(item?.number_candidates || "0"), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_Button, {
                        class: _normalizeClass([
                        item.has_challenge_assigned
                          ? 'cursor-not-allowed text-gray-500'
                          : '',
                      ]),
                        disabled: item.has_challenge_assigned,
                        variant: "outlined",
                        label: "Add challenge",
                        labelSize: "text-xs",
                        onOnClick: ($event: any) => (_ctx.openChallenge(item.id))
                      }, {
                        startIcon: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled", "onOnClick"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Button, {
                        class: _normalizeClass([item.has_evaluation ? 'cursor-not-allowed' : '']),
                        disabled: item.has_evaluation,
                        variant: "outlined",
                        label: "Add evaluation",
                        labelSize: "text-xs",
                        onOnClick: ($event: any) => (_ctx.openTemplate(item.id))
                      }, {
                        startIcon: _withCtx(() => [
                          _hoisted_39
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled", "onOnClick"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_MenuJob, {
                  jobId: item.id,
                  hasChallenge: item.has_challenge_assigned,
                  showAssing: _ctx.showAssing,
                  hasEvaluation: item.has_evaluation,
                  isManaged: item.is_managed,
                  jobStatus: item.job_status,
                  hasRecruiter: item?.responsible_recruiter ? true : false,
                  onOpenTemplate: ($event: any) => (_ctx.openTemplate(item.id)),
                  onOpenEvaluation: ($event: any) => (_ctx.openTemplate(item.id)),
                  onOpenChallenge: ($event: any) => (_ctx.openChallenge(item.id)),
                  onDeactivateJob: ($event: any) => (_ctx.deactivateJob(item)),
                  onAssignJob: ($event: any) => (_ctx.assignJob(item)),
                  onAcceptManageJob: ($event: any) => (_ctx.acceptManageJob(item)),
                  isClosedJob: item.is_closed
                }, null, 8, ["jobId", "hasChallenge", "showAssing", "hasEvaluation", "isManaged", "jobStatus", "hasRecruiter", "onOpenTemplate", "onOpenEvaluation", "onOpenChallenge", "onDeactivateJob", "onAssignJob", "onAcceptManageJob", "isClosedJob"])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("span", _hoisted_43, "Last interaction: " + _toDisplayString(_ctx.timeAgo(item?.last_interaction)), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  (item.responsible_recruiter)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _hoisted_49,
                          _createElementVNode("span", _hoisted_50, _toDisplayString(item.responsible_recruiter.first_name) + " " + _toDisplayString(item.responsible_recruiter.last_name), 1),
                          (item.recruiter_assigned_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                _hoisted_52,
                                _createVNode(_component_DateFormatter, {
                                  date: item.recruiter_assigned_date
                                }, null, 8, ["date"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_56))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row justify-center mt-4", index === _ctx.activeItem && 'py-1'])
      }, [
        _createElementVNode("button", {
          onClick: ($event: any) => (_ctx.expandCard(index)),
          class: "rounded hover:bg-gray-100"
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(["h-6 w-6 text-gray-400", _ctx.activeItem === index && 'transform rotate-180']),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, _hoisted_59, 2))
        ], 8, _hoisted_57)
      ], 2),
      (index === _ctx.activeItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("span", _hoisted_62, _toDisplayString(item.description ? item.description : "No description assigned "), 1)
            ]),
            _createElementVNode("div", _hoisted_63, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.job_stages, (el, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["flex items-center", [
            el.stage.name === 'Rejected' ? 'text-red-900' : 'text-gray-900',
          ]])
                }, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["block mx-auto text-xs h-8 text-center p-2 rounded", [
                el.stage.name === 'Rejected' ? 'bg-red-200' : 'bg-gray-200',
              ]])
                    }, _toDisplayString(el.number_candidates), 3),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(el.stage.name), 1)
                  ]),
                  (
              i !== item.job_stages.length - 1 &&
              i !== item.job_stages.length - 2
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
                    : (i === item.job_stages.length - 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, " | "))
                      : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2))
  }), 128))
}